import * as React from 'react';

import { Color, IconName } from '../../enums';
import { Icon } from '../icon/icon.component';

import { CloseButton, Container, Label } from './badge.styled';
import { BadgeProps } from './badge.types';

export const Badge: React.FC<BadgeProps> = (props: BadgeProps): JSX.Element => {
  const { color, background = Color.White, border = Color.Transparent, label, icon, onClose, className }: BadgeProps = props;

  return (
    <Container
      $background={background}
      $color={color}
      $border={border}
      className={className}
    >
      {icon && <Icon name={icon} size={16} color={color} />}
      <Label>
        {label}
      </Label>
      {onClose && (
        <CloseButton onClick={onClose}>
          <Icon name={IconName.CloseSmallest} size={16} color={color} />
        </CloseButton>
      )}
    </Container>
  );
};
